import { tableStatusCourse } from './../../enum/tableStatusCourse';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DEFAULT_PAGE_SIZE } from '../../../cadastro/admin/lib/constants';
import { OrderTableEnum } from '../../../cadastro/admin/models/enums/orderTableEnum';
import { FilterState } from '../../../cadastro/admin/services/states/filter.state';
import { Router } from '@angular/router';
import { shareReplay } from 'rxjs';
import { throwDialogContentAlreadyAttachedError } from '@angular/cdk/dialog';
import { LexTranslateService } from '@app/core/services/lex-translate.service';

export interface ILexTable {
  columns: Column[];
  data: any[];
  subtitle?: Subtitle;
  status?: Status;
}

interface Column {
  id: string;
  name?: string;
  width?: string;
  count?: number;
  acronym?: string;
  foldable?: {
    content: string,
    bindLabel?: any,
    contentWidth?: any,
    ngStyle?: any;
  };
  pill?: {
    labeling: () => string,
    styling: () => object,
    propertyName: string;
  };
  iconText?: { propertyName: string, iconWidth?: string };
  ordination?: {
    orderType: number;
  };
  ngClass?: string;
  ngStyle?: object;
  actionButton?: any;
}

interface Subtitle {
  name: string;
  data: SubtitleData[];
}

interface SubtitleData {
  ngStyle: object;
  ngClass: string;
  label: string;
}

export interface Status {
  colorName: string;
  label: string;
}
@Component({
  selector: 'seb-table-status-course',
  templateUrl: './table-status-course.component.html',
  styleUrls: ['./table-status-course.component.css']

})
export class TableStatusCourseComponent implements OnInit {

  @Input() data: any[];
  @Input() columns: Column[];
  @Input() subtitle: Subtitle;
  @Input() status: Status;
  @Input() showStatus = false;
  @Input() showCheckboxes = false;
  @Input() showNumberUsers = false;
  @Input() preloader: boolean;
  @Input() noDataText = ""

  @Input() showPagination = false;
  @Input() paginationSize: number;
  @Input() initialPage: number;

  @Input() origin: tableStatusCourse;

  @Output() changePage = new EventEmitter();
  @Output() openItemEdit = new EventEmitter();
  @Output() actionButton = new EventEmitter();
  @Output() sortColumn = new EventEmitter();
  @Output() evModalSelectedItems = new EventEmitter();

  @Output() notifySelectCheck = new EventEmitter();

  @Input() ngClass: string;

  activeReadOnly = false;
  readonly = false;

  divDetailLeft: string = "0";
  divDetailTop: string = "0";

  showDetailsUser = false;

  numberUsers: number = 0;

  selectedItemsIds = {};
  itemsPerPage = DEFAULT_PAGE_SIZE;

  objSubtitle: Subtitle;
  showSubtitle = false;
  tableSelected: tableStatusCourse = 0;

  colorReadOnly: "headerReadOnly";
  colorHeadInitial: 'black';

  objSortInitialData: any = {
    "id": "name",
    "ordination": {
      "orderType": OrderTableEnum.Descending
    }
  }

  constructor(
    private filterState: FilterState,
    private route: Router,
    public lextranslate: LexTranslateService
  ) { }

  async ngOnInit() {

    
    if (this.subtitle) {
      this.showSubtitle = true;
    }
    
    if (!this.initialPage) {
      this.initialPage = 1;
    }
    const stateOrdination = this.filterState.states.ordination;
    if (stateOrdination.fieldNameSort) {
      const newColumns = this.columns.map(col => {
        if (col.id === stateOrdination.fieldNameSort && col.ordination) {
          if (stateOrdination.isDesc) {
            return { ...col, ordination: { orderType: OrderTableEnum.Descending } };
          } else {
            return { ...col, ordination: { orderType: OrderTableEnum.Ascending } };
          }
        } else if (col.ordination) {
          return { ...col, ordination: { orderType: OrderTableEnum.NotOrder } };
        } else {
          return col;
        }
      });
      this.columns = newColumns;
    }
    
    await this.lextranslate.loadTranslationsInFunctionOfTenant()
    this.noDataText = `${this.lextranslate.i18n['cbdc5d8a-05c5-488e-bd5f-afc092629c8d']}!`    
    this.noDataText = `${this.lextranslate.i18n["cbdc5d8a-05c5-488e-bd5f-afc092629c8d"]}!`
    this.onSortColumn(this.objSortInitialData);
  }
  
  
  tooltipShow(event){

    this.divDetailLeft = event.clientX;
    this.divDetailTop = event.screenY;

    this.showDetailsUser = true;

  }
  tooltipHide(){
    this.showDetailsUser = false;
  }

  redirectToItemEdit(event, item) {
    if (this.readonly || event.target.classList.contains('js-action') || event.target.classList.contains('input-span') || event.target.localName === 'input') {
      return
    }

    const selection = window.getSelection()

    requestAnimationFrame(() => {
      const hasSelection = selection ? (selection.type ? selection.type.toLowerCase() === 'range' : selection.toString().length > 0) : false

      if (!hasSelection) {
        this.openItemEdit.emit(item);
      }
    })
  }

  callAction($event, actionId, rowData) {
    this.actionButton.emit({ actionId, rowData, $event });
  }

  toggleSelection(oneData, origin) {
    if (oneData._checkbox && (oneData._checkbox.disabled || oneData._checkbox.hidden)) {
      return
    }

    this.selectedItemsIds[oneData.id] = this.selectedItemsIds[oneData.id] ? null : oneData;

    if (this.selectedItems.length > 0) {
      this.tableSelected = origin;
    } else {
      this.tableSelected = 0;
    }
    this.notifySelectCheck.emit([this.selectedItems, origin]);

  }

  get areAllSelected() {
    const itemsAmount = this.data.filter((item) => !(item._checkbox && (item._checkbox.disabled || item._checkbox.hidden))).length;
    return itemsAmount > 0 &&
      this.selectedItems.filter((item) => !!this.data.find((c) => c.id === item.id)).length === itemsAmount;
  }

  get selectedItems(): Array<any> {
    return Object.values(this.selectedItemsIds).filter((item) => !!item);
  }

  get countSelectedItems() {
    return this.selectedItems.length;
  }

  get selectedItemsPrimary() {
    const selectedItems = this.selectedItems;
    const primaryValues = {};

    for (const selectedItem of selectedItems) {
      primaryValues[selectedItem.id] = true;
    }

    return primaryValues;
  }

  toggleAllSelection(origin) {
    const wereAllSelected = this.areAllSelected;
    const selectAvailableItems = this.data.filter((item) => !(item._checkbox
      && (item._checkbox.disabled || item._checkbox.hidden)))
    for (const item of selectAvailableItems) {
      this.selectedItemsIds[item.id] = wereAllSelected ? null : item;
    }

    if (this.selectedItems.length > 0) {
      this.tableSelected = origin;
    } else {
      this.tableSelected = 0;
    }
    this.notifySelectCheck.emit([this.selectedItems, origin]);

  }

  onIndexPag(indexPage) {
    this.changePage.emit(indexPage);
  }

  onSortColumn(column) {
    let isDesc: boolean;
    const columnOrderType = column.ordination.orderType;
    if (columnOrderType === OrderTableEnum.Descending || columnOrderType === OrderTableEnum.NotOrder) {
      column.ordination.orderType = OrderTableEnum.Ascending;
      isDesc = false;
    } else if (columnOrderType === OrderTableEnum.Ascending) {
      column.ordination.orderType = OrderTableEnum.Descending;
      isDesc = true;
    }
    
    const newColumns = this.columns.map(col => {
      if (col.id !== column.id && col.ordination) {
        return { ...col, ordination: { orderType: OrderTableEnum.NotOrder } };
      } else {
        return col;
      }
    });

    this.columns = newColumns;
    this.sortColumn.emit({ id: column.id, isDesc });
  }

  openModalSelectedItems() {
    this.evModalSelectedItems.emit();
  }

  clearAllSelectedItems() {
    this.selectedItemsIds = {};
  }

  getAcronym(name: string){
    var listNome = name.split(" ")

    var primeiro = listNome[0]

    if (listNome.length > 1) {
      var ultimo = listNome[listNome.length - 1]

      var sigla = primeiro.substr(0, 1) + ultimo.substr(0, 1)

    } else {
      var sigla = primeiro.substr(0, 2)

    }
    return sigla.toUpperCase();
  }

  getDocument(id){
    var user = this.data.find(d => d.id === id);
    return (user.document !== null ? user.document : '');
  }

  getEmail(id){
    var user = this.data.find(d => d.id === id);
    return (user.email !== null ? user.email : '');
  }

  getBirthDate(id){
    var user = this.data.find(d => d.id === id);
    return (user.birthDate ? user.birthDate : '01/01/1990');
  }

  getUserRedirect (userId: string) {
    return `usuarios/editar-usuario/${userId}`;
  }

  redirectToUser (userId: string) {
    this.route.navigate([`/${this.getUserRedirect(userId)}`])
  }

 

}
